// const getColorObject = (
//   hexCode: string,
//   name: string,
//   isUsed: boolean,
//   isDefault?: boolean
// ): ColorItem => ({
//   id: getId(),
//   hexCode,
//   name,
//   isUsed,
//   defaultColor: isDefault,
// })
//
// const getColors = ({
//   arr,
//   type,
//   isDefault,
// }: {
//   arr: any[]
//   type?: string
//   isDefault?: boolean
// }): ColorItem[] => {
//   return (
//     arr?.reduce((acc, item): ColorItem[] => {
//       let color
//
//       if (typeof item === 'object') {
//         color = item.color
//       }
//
//       if (typeof item === 'string') {
//         color = item
//       }
//
//       const upperCaseColor = color?.toUpperCase()
//
//       return [
//         ...acc,
//         getColorObject(upperCaseColor, upperCaseColor, !!type, isDefault),
//       ]
//     }, []) || []
//   )
// }

//
// export const mappedColors = (state: any) => {
//   const defaultColors = COLORS
//
//   // got all colors
//   const blockColors = getColors({ arr: state.blocks, type: 'block' })
//   const treeColors = getColors({ arr: state.tree, type: 'tree' })
//
//   const symbolColors = state.project.symbolsLibrary
//     ? getColors({ arr: state.project.symbolsLibrary })
//     : []
//   const customColors = getColors({ arr: state.project.customColors })
//   const legendColors = state.project.legendItems
//     ? Object.keys(state.project.legendItems).map((hex) => {
//         const colorName = state.project.legendItems[hex]
//         return getColorObject(hex.toUpperCase(), colorName, false)
//       })
//     : []
//   const defaultColor = getColors({
//     arr: [state.project.blockColor],
//     isDefault: true,
//   })
//   const frameColor = getColors({
//     arr: [state.project.treeColor],
//   })
//
//   // concat all colors
//   const concatColors = [
//     ...symbolColors,
//     ...treeColors,
//     ...blockColors,
//     ...defaultColor,
//     ...frameColor,
//     ...customColors,
//     ...legendColors,
//   ]
//
//   // mapped of colors to replace the name/hex code
//   const mappedAllColors = concatColors
//     .filter((item) => !!item.hexCode && !!item.name)
//     .map((item: ColorItem): ColorItem => {
//       const clonedItem = { ...item }
//       const defaultColorByName = defaultColors.find(
//         (color) => color.name.toUpperCase() === clonedItem.name
//       )
//       const equalColorByHex = defaultColors.find(
//         (color) => color.hexCode.toUpperCase() === clonedItem.hexCode
//       )
//       const equalColorByHexName = defaultColors.find(
//         (color) => color.name.toUpperCase() === clonedItem.hexCode
//       )
//
//       if (clonedItem.name === 'DEFAULT') {
//         const blueColor = defaultColors.find((color) => color.defaultColor)
//         clonedItem.name = blueColor?.name.toUpperCase() || 'Blue'
//         clonedItem.hexCode = blueColor?.hexCode.toUpperCase() || '#2F7FEF'
//       }
//
//       if (defaultColorByName) {
//         clonedItem.hexCode = defaultColorByName.hexCode
//       }
//
//       if (equalColorByHex) {
//         if (clonedItem.name === clonedItem.hexCode) {
//           clonedItem.name = equalColorByHex.name.toUpperCase()
//         }
//       }
//
//       if (!clonedItem.hexCode?.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
//         if (equalColorByHexName) {
//           clonedItem.hexCode = equalColorByHexName.hexCode
//         }
//       }
//
//       clonedItem.name =
//         clonedItem.name.charAt(0).toUpperCase() +
//         clonedItem.name.toLowerCase().slice(1)
//
//       return clonedItem
//     })
//
//   return mappedAllColors.reduce((acc: ColorItem[], item: ColorItem) => {
//     const matchingItemIndex = acc.findIndex(
//       ({ hexCode }) => hexCode === item.hexCode
//     )
//
//     if (matchingItemIndex >= 0) {
//       let { isUsed, defaultColor } = acc[matchingItemIndex]
//
//       if (!item.isUsed) {
//         isUsed = true
//       }
//
//       if (item.defaultColor) {
//         defaultColor = item.defaultColor
//       }
//
//       acc[matchingItemIndex] = {
//         ...item,
//         isUsed,
//         defaultColor,
//       }
//
//       return acc
//     }
//
//     if (!item.hexCode?.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
//       return acc
//     }
//
//     return [...acc, item]
//   }, [])
// }
//
// export const updateProjectColors = (data: { color: string }[]): any[] => {
//   return data.map((item) => {
//     if (item.color && !item.color.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
//       item.color = COLORS_HEX[item.color] || item.color
//
//       return { ...item }
//     }
//
//     return item
//   })
// }

export const isValidHexColor = (str: string): boolean => {
  return /#([\da-fA-F]{3,4}|[\da-fA-F]{6}|[\da-fA-F]{8})$/.test(str)
}

export const hexToRgba = (hex: string, alpha: number = 1) => {
  if (alpha < 0 || alpha > 1) {
    throw new Error('Alpha channel must be between 0 and 1')
  }

  const cleanHex = hex.replace('#', '')

  const hexParsers = {
    3: (h: string) => [...h].map((c) => parseInt(c + c, 16)),
    6: (h: string) => [
      parseInt(h.substring(0, 2), 16),
      parseInt(h.substring(2, 4), 16),
      parseInt(h.substring(4, 6), 16),
    ],
  }

  const parser = hexParsers[cleanHex.length as keyof typeof hexParsers]
  if (!parser) {
    throw new Error('Invalid HEX format')
  }

  const [r, g, b] = parser(cleanHex)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

type RgbTriple = [number, number, number]

// Same parsing as hexToRgba, but a bad value is an answer rather than an exception:
// palettes are user-edited and a single malformed entry must not take a caller down.
const parseHex = (hex: string): RgbTriple | null => {
  const clean = hex.trim().replace('#', '')

  if (!/^([0-9a-f]{3}|[0-9a-f]{6})$/i.test(clean)) {
    return null
  }

  const pairs =
    clean.length === 3
      ? [...clean].map((char) => char + char)
      : [clean.slice(0, 2), clean.slice(2, 4), clean.slice(4, 6)]

  return pairs.map((pair) => parseInt(pair, 16)) as RgbTriple
}

/**
 * `hex` with its HSB brightness lowered by `points` (of 100) and the given alpha, as
 * an rgba() string. Brightness is the brightest channel as a whole percent, the way
 * Figma shows it; lowering it scales all three channels alike, so hue and saturation
 * stay put. #fefa6c minus 20 gives Figma's rgb(204, 201, 87) to the digit.
 *
 * Returns null for a hex that does not parse; the caller picks the fallback.
 */
export const dimHexToRgba = (
  hex: string,
  points: number,
  alpha: number
): string | null => {
  const rgb = parseHex(hex)

  if (!rgb) {
    return null
  }

  const max = Math.max(...rgb)
  const brightness = Math.round((max / 255) * 100)
  const target = (Math.max(brightness - points, 0) / 100) * 255
  const scale = max > 0 ? target / max : 0
  const [r, g, b] = rgb.map((channel) => Math.round(channel * scale))

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

// "Redmean" — a cheap approximation of perceived difference that behaves noticeably
// better than plain RGB distance around saturated colours, which is exactly where a
// palette sits. Squared, because only the ordering matters.
const perceivedDistance = (a: RgbTriple, b: RgbTriple): number => {
  const redMean = (a[0] + b[0]) / 2
  const [dr, dg, db] = [a[0] - b[0], a[1] - b[1], a[2] - b[2]]

  return (
    (2 + redMean / 256) * dr * dr +
    4 * dg * dg +
    (2 + (255 - redMean) / 256) * db * db
  )
}

/**
 * The entry of `palette` that looks closest to `hex`.
 *
 * For picking a stand-in when a wanted colour is not in a project's palette: returning
 * the nearest thing that is there keeps colour-coded items distinguishable, where
 * falling back to one default would flatten them all into the same colour.
 *
 * Returns null when nothing can be compared — an empty palette, or a hex that does not
 * parse. Callers decide what that means; usually the project's default colour.
 */
export const nearestHexColor = (
  hex: string,
  palette: readonly string[]
): string | null => {
  const target = parseHex(hex)

  if (!target) {
    return null
  }

  const closest = palette.reduce<{ distance: number; hex: string | null }>(
    (best, candidate) => {
      const rgb = parseHex(candidate)

      if (!rgb) {
        return best
      }

      const distance = perceivedDistance(target, rgb)

      return distance < best.distance ? { distance, hex: candidate } : best
    },
    { distance: Number.POSITIVE_INFINITY, hex: null }
  )

  return closest.hex
}
